exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.info-container[data-v-9415bf04]{height:99%;width:100%;padding-bottom:60px;-webkit-box-sizing:border-box;box-sizing:border-box\n}\n", "", {"version":3,"sources":["D:/java/social-training/省内平台手机/src/view/entrepreneurship/D:/java/social-training/省内平台手机/src/view/entrepreneurship/entrepreneurship.vue"],"names":[],"mappings":";AAwCA,iCACE,WACA,WACA,oBACA,8BAAA,qBAAsB;CACvB","file":"entrepreneurship.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n.info-container {\r\n  height: 99%;\r\n  width: 100%;\r\n  padding-bottom: 60px;\r\n  box-sizing: border-box;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9415bf04","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/view/entrepreneurship/entrepreneurship.vue
// module id = sH1g
// module chunks = 49